import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Nav from "../components/Nav";

const Profile = () => {
  const { isAuthenticated } = useAuth0();

  return (
    isAuthenticated && (
      <div>
        <Nav />
      </div>
    )
  );
};

export default Profile;
